import {
  ActivityNotification as ActivityNotificationType,
  DocumentAccessGrantedNotification as DocumentAccessGrantedNotificationType,
  DocumentSigningNotification as DocumentSigningNotificationType,
  LeadNotification as LeadNotificationType,
  MessageNotification as MessageNotificationType,
  OpenHouseOnFavoriteCaseNotification as OpenHouseOnFavoriteCaseNotificationType,
  PriceChangeOnFavoriteCaseNotification as PriceChangeOnFavoriteCaseNotificationType,
  PriceChangedOnMatchedCaseNotification as PriceChangedOnMatchedCaseNotificationType,
  RequestedDocumentNotification as RequestedDocumentNotificationType,
  SearchProfileMatchNotification as SearchProfileMatchNotificationType,
  SearchProfileMatchedCaseNotification as SearchProfileMatchedCaseNotificationType,
} from 'Types';
import type { notificationComponent_fragment$key } from '__generated__/notificationComponent_fragment.graphql';
import { LeadNotification } from 'components/organisms/notifications/components/lead-notification';
import { OpenHouseFavouriteCaseNotification } from 'components/organisms/notifications/components/open-house-favorite-case-notification.tsx';
import { PriceChangeFavoriteCaseNotification } from 'components/organisms/notifications/components/price-change-favorite-case-notification.tsx';
import { PriceChangeOnMatchCaseNotification } from 'components/organisms/notifications/components/price-change-on-match-case-notification.tsx';
import { type FC, Fragment } from 'react';
import { graphql, useFragment } from 'react-relay';
import { getNotificationUrl } from 'utils/navigation';
import { ActivityNotification } from './activity-notification';
import { DocumentAccessGrantedNotification } from './document-access-granted-notification';
import { DocumentSigningNotification } from './document-signing-notification';
import { MessageNotification } from './message-notification';
import { RequestedDocumentNotification } from './requested-document-notification';
import { SearchProfileMatchNotification } from './search-profile-match-notification';
import { SearchProfileMatchedCaseNotification } from './search-profile-matched-case-notification';

export interface Props {
  notification: notificationComponent_fragment$key;
}

const notificationComponent = graphql`
  fragment notificationComponent_fragment on NotificationInterface {
    __typename
    ... on MessageNotification {
      threadId
    }
    ...messageNotification_fragment
    ...documentSigningNotification_fragment
    ...activityNotification_fragment
    ...searchProfileMatchNotification_fragment
    ...requestedDocumentNotification_fragment
    ...searchProfileMatchedCaseNotification_fragment
    ...documentAccessGrantedNotification_fragment
    ...leadNotification_fragment
    ...priceChangeFavoriteCaseNotification_fragment
    ...priceChangeOnMatchCaseNotification_fragment
    ...openHouseFavoriteCaseNotification_fragment
  }
`;

export const NotificationComponent: FC<Props> = (props) => {
  const data = useFragment<notificationComponent_fragment$key>(notificationComponent, props.notification);

  switch (data.__typename) {
    case MessageNotificationType:
      return (
        <MessageNotification
          notification={data}
          url={getNotificationUrl({ notificationType: data.__typename, threadId: data.threadId })}
        />
      );
    case DocumentSigningNotificationType:
      return <DocumentSigningNotification notification={data} />;
    case DocumentAccessGrantedNotificationType:
      return <DocumentAccessGrantedNotification notification={data} />;
    case RequestedDocumentNotificationType:
      return <RequestedDocumentNotification notification={data} />;
    case ActivityNotificationType:
      return <ActivityNotification notification={data} />;
    case SearchProfileMatchNotificationType:
      return <SearchProfileMatchNotification notification={data} />;
    case SearchProfileMatchedCaseNotificationType:
      return <SearchProfileMatchedCaseNotification notification={data} />;
    case LeadNotificationType:
      return <LeadNotification notification={data} />;
    case OpenHouseOnFavoriteCaseNotificationType:
      return <OpenHouseFavouriteCaseNotification notification={data} />;
    case PriceChangeOnFavoriteCaseNotificationType:
      return <PriceChangeFavoriteCaseNotification notification={data} />;
    case PriceChangedOnMatchedCaseNotificationType:
      return <PriceChangeOnMatchCaseNotification notification={data} />;
    default:
      return <Fragment />;
  }
};
